module.exports = __webpack_public_path__ + "assets/35443111d4cb7976478c3c36c56d6e0b.mp3";